/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Whether the vendor is discoverable by every tenant (VISIBLE) or only by the tenants that own it or hold an entitled survey from it (PROTECTED).
 */
export enum SurveyVendorVisibility {
    VISIBLE = 'VISIBLE',
    PROTECTED = 'PROTECTED',
}
